import { ADDITIONAL_COURSE_ID } from "../Constants/courses"

export function isCourseBuilderWorkshop(pyp) {
  return Number(pyp?.navigation?.currentCourseId) === ADDITIONAL_COURSE_ID
}

/** True when course-builder learner is on the last part of the last module. */
export function isCourseBuilderEndOfCourse(pyp) {
  if (!isCourseBuilderWorkshop(pyp)) return false

  const partIds = pyp?.parts?.allIds || []
  const moduleIds = pyp?.modules?.allIds || []
  if (!partIds.length || !moduleIds.length) return false

  const currentPartId = Number(pyp?.navigation?.currentPartId)
  const currentModuleId = Number(pyp?.navigation?.currentModuleId)
  const partIndex = partIds.findIndex((id) => Number(id) === currentPartId)
  const moduleIndex = moduleIds.findIndex((id) => Number(id) === currentModuleId)

  return (
    partIndex >= 0 &&
    moduleIndex >= 0 &&
    partIndex === partIds.length - 1 &&
    moduleIndex === moduleIds.length - 1
  )
}

export const buildWorkshopLocation = (moduleTitle, navigation, suffix = "") => {
  const { currentCourseId, currentCourseName } = navigation || {}
  const pathname = `/workshop/${moduleTitle}${suffix}`
  const useCourseId =
    currentCourseId != null &&
    Number(currentCourseId) === ADDITIONAL_COURSE_ID
  return {
    pathname,
    search: useCourseId ? `?courseId=${currentCourseId}` : "",
    state: useCourseId
      ? { courseId: currentCourseId, courseName: currentCourseName }
      : { courseName: currentCourseName || "Pursue Your Purpose" }
  }
}
